// POS SYSTEM Saga
import { takeEvery, put, call, all, fork } from "redux-saga/effects";
import {
  GET_POS_SYSTEM_RENDER_DATA,
  GET_POS_SYSTEM_LIST,
  GET_POS_SYSTEM_DATA,
  CREATE_POS_SYSTEM,
  UPDATE_POS_SYSTEM,
  DELETE_POS_SYSTEM,
  GET_POS_SYSTEM_TO_USER_LIST,
  GET_POS_SYSTEM_TO_USER_DATA,
  CREATE_POS_SYSTEM_TO_USER,
  UPDATE_POS_SYSTEM_TO_USER,
  DELETE_POS_SYSTEM_TO_USER,
  GET_POS_ORDER_LIST,
  POS_ORDER_SEARCH,
  GET_POS_ORDER_DATA,
  CREATE_POS_ORDER,
  UPDATE_POS_ORDER,
  DELETE_POS_ORDER,
  CREATE_POS_ORDER_PAYMENT_REQUEST,
  CREATE_POS_ORDER_TENDER,
  GET_POS_SYSTEM_OVERVIEW,
  VOID_POS_ORDER_PAYMENT_REQUEST,
  PRINT_POS_ORDER_RECEIPT,
  EMAIL_POS_ORDER_RECEIPT,
  REFUND_POS_ORDER,
} from "./actionType";
import {
  getPosSystemRenderDataSuccess,
  getPosSystemRenderDataFailure,
  getPosSystemListSuccess,
  getPosSystemListFailure,
  getPosSystemDataSuccess,
  getPosSystemDataFailure,
  createPosSystemSuccess,
  createPosSystemFailure,
  updatePosSystemSuccess,
  updatePosSystemFailure,
  deletePosSystemSuccess,
  deletePosSystemFailure,
    getPosSystemToUserListSuccess,
    getPosSystemToUserListFailure,
    getPosSystemToUserDataSuccess,
    getPosSystemToUserDataFailure,
    createPosSystemToUserSuccess,
    createPosSystemToUserFailure,
    updatePosSystemToUserSuccess,
    updatePosSystemToUserFailure,
    deletePosSystemToUserSuccess,
    deletePosSystemToUserFailure,
    getPosOrderListSuccess,
    getPosOrderListFailure,
    posOrderSearchSuccess,
    posOrderSearchFailure,
    getPosOrderDataSuccess,
    getPosOrderDataFailure,
    createPosOrderSuccess,
    createPosOrderFailure,
    updatePosOrderSuccess,
    updatePosOrderFailure,
    deletePosOrderSuccess,
    deletePosOrderFailure,
    createPosOrderPaymentRequestSuccess,
    createPosOrderPaymentRequestFailure,
    createPosOrderTenderSuccess,
    createPosOrderTenderFailure,
      getPosSystemOverviewSuccess,
      getPosSystemOverviewFailure,
        voidPosOrderPaymentRequestSuccess,
        voidPosOrderPaymentRequestFailure,
        printPosOrderReceiptSuccess,
          printPosOrderReceiptFailure,
        emailPosOrderReceiptSuccess,
        emailPosOrderReceiptFailure,
          refundPosOrderSuccess,
          refundPosOrderFailure,
}  from "./action";
// Note: These helper functions are expected to be implemented in fakebackend_helper.js
import {
  getPosSystemRenderDataAPI,
  getPosSystemListAPI,
  getPosSystemDataAPI,
  createPosSystemAPI,
  updatePosSystemAPI,
  deletePosSystemAPI,
  getPosSystemToUserListAPI,
  getPosSystemToUserDataAPI,
  createPosSystemToUserAPI,
  updatePosSystemToUserAPI,
  deletePosSystemToUserAPI,
  getPosOrderListAPI,
  posOrderSearchAPI,
  getPosOrderDataAPI,
  createPosOrderAPI,
  updatePosOrderAPI,
  deletePosOrderAPI,
    createPosOrderPaymentRequestAPI,
    posOrderTenderAPI,
    getPosSystemOverviewAPI,
    voidPosOrderPaymentRequestAPI,
    printPosOrderReceiptAPI,
    emailPosOrderReceiptAPI,
    refundPosOrderAPI,
} from "../../helpers/fakebackend_helper";

function* getPosSystemRenderDataItems({ payload }) {
  try {
    const response = yield call(getPosSystemRenderDataAPI, payload);
    yield put(getPosSystemRenderDataSuccess(response));
  } catch (error) {
    yield put(getPosSystemRenderDataFailure(error));
  }
}

function* getPosSystemList() {
  try {
    const response = yield call(getPosSystemListAPI);
    yield put(getPosSystemListSuccess(response));
  } catch (error) {
    yield put(getPosSystemListFailure(error));
  }
}

function* getPosSystemData({ payload }) {
  try {
    const response = yield call(getPosSystemDataAPI, payload);
    yield put(getPosSystemDataSuccess(response));
  } catch (error) {
    yield put(getPosSystemDataFailure(error));
  }
}

function* createPosSystem({ payload }) {
  try {
    const response = yield call(createPosSystemAPI, payload);
    yield put(createPosSystemSuccess(response));
  } catch (error) {
    yield put(createPosSystemFailure(error));
  }
}

function* updatePosSystem({ payload }) {
  try {
    const response = yield call(updatePosSystemAPI, payload);
    yield put(updatePosSystemSuccess(response));
  } catch (error) {
    yield put(updatePosSystemFailure(error));
  }
}

function* deletePosSystem({ payload }) {
  try {
    const response = yield call(deletePosSystemAPI, payload);
    yield put(deletePosSystemSuccess(response));
  } catch (error) {
    yield put(deletePosSystemFailure(error));
  }
}

//GET_POS_SYSTEM_TO_USER_LIST
function* getPosSystemToUserList() {
  try {
    const response = yield call(getPosSystemToUserListAPI);
    yield put(getPosSystemToUserListSuccess(response));
  } catch (error) {
    yield put(getPosSystemToUserListFailure(error));
  }
}

//GET_POS_SYSTEM_TO_USER_DATA
function* getPosSystemToUserData({ payload }) {
  try {
    const response = yield call(getPosSystemToUserDataAPI, payload);
    yield put(getPosSystemToUserDataSuccess(response));
  } catch (error) {
    yield put(getPosSystemToUserDataFailure(error));
  }
}

//CREATE_POS_SYSTEM_TO_USER
function* createPosSystemToUser({ payload }) {
  try {
    const response = yield call(createPosSystemToUserAPI, payload);
    yield put(createPosSystemToUserSuccess(response));
  } catch (error) {
    yield put(createPosSystemToUserFailure(error));
  }
}

//UPDATE_POS_SYSTEM_TO_USER
function* updatePosSystemToUser({ payload }) {
  try {
    const response = yield call(updatePosSystemToUserAPI, payload);
    yield put(updatePosSystemToUserSuccess(response));
  } catch (error) {
    yield put(updatePosSystemToUserFailure(error));
  }
}

//DELETE_POS_SYSTEM_TO_USER
function* deletePosSystemToUser({ payload }) {
  try {
    const response = yield call(deletePosSystemToUserAPI, payload);
    yield put(deletePosSystemToUserSuccess(response));
  } catch (error) {
    yield put(deletePosSystemToUserFailure(error));
  }
}

// POS ORDER - List
function* getPosOrderList() {
  try {
    const response = yield call(getPosOrderListAPI);
    yield put(getPosOrderListSuccess(response));
  } catch (error) {
    yield put(getPosOrderListFailure(error));
  }
}

// POS ORDER - Search
function* posOrderSearch({ payload }) {
  try {
    const response = yield call(posOrderSearchAPI, payload);
    yield put(posOrderSearchSuccess(response));
  } catch (error) {
    yield put(posOrderSearchFailure(error));
  }
}

// POS ORDER - Data
function* getPosOrderData({ payload }) {
  try {
    const response = yield call(getPosOrderDataAPI, payload);
    yield put(getPosOrderDataSuccess(response));
  } catch (error) {
    yield put(getPosOrderDataFailure(error));
  }
}

// POS ORDER - Create
function* createPosOrder({ payload }) {
  try {
    const response = yield call(createPosOrderAPI, payload);
    yield put(createPosOrderSuccess(response));
  } catch (error) {
    yield put(createPosOrderFailure(error));
  }
}

// POS ORDER - Update
function* updatePosOrder({ payload }) {
  try {
    const response = yield call(updatePosOrderAPI, payload);
    yield put(updatePosOrderSuccess(response));
  } catch (error) {
    yield put(updatePosOrderFailure(error));
  }
}

// POS ORDER - Delete
function* deletePosOrder({ payload }) {
  try {
    const response = yield call(deletePosOrderAPI, payload);
    yield put(deletePosOrderSuccess(response));
  } catch (error) {
    yield put(deletePosOrderFailure(error));
  }
}

// POS ORDER - Create Payment Request
function* createPosOrderPaymentRequest({ payload }) {
  try {
    const response = yield call(createPosOrderPaymentRequestAPI, payload);
    yield put(createPosOrderPaymentRequestSuccess(response));
  } catch (error) {
    yield put(createPosOrderPaymentRequestFailure(error));
  }
}

// POS ORDER - Create Tender (cash / voucher / account)
function* createPosOrderTender({ payload }) {
  try {
    const response = yield call(posOrderTenderAPI, payload);
    yield put(createPosOrderTenderSuccess(response));
  } catch (error) {
    yield put(createPosOrderTenderFailure(error));
  }
}

// POS SYSTEM - Overview
function* getPosSystemOverview({ payload }) {
  try {
    const response = yield call(getPosSystemOverviewAPI, payload);
    yield put(getPosSystemOverviewSuccess(response));
  } catch (error) {
    yield put(getPosSystemOverviewFailure(error));
  }
}

// VOID_POS_ORDER_PAYMENT_REQUEST
function* voidPosOrderPaymentRequest({ payload }) {
  try {
    const response = yield call(voidPosOrderPaymentRequestAPI, payload);
    yield put(voidPosOrderPaymentRequestSuccess(response));
  } catch (error) {
    yield put(voidPosOrderPaymentRequestFailure(error));
  }
}

// PRINT_POS_ORDER_RECEIPT
function* printPosOrderReceipt({ payload }) {
  try {
    const response = yield call(printPosOrderReceiptAPI, payload);
    yield put(printPosOrderReceiptSuccess(response));
  } catch (error) {
    yield put(printPosOrderReceiptFailure(error));
  }
}

// EMAIL_POS_ORDER_RECEIPT
function* emailPosOrderReceipt({ payload }) {
  try {
    const response = yield call(emailPosOrderReceiptAPI, payload);
    yield put(emailPosOrderReceiptSuccess(response));
  } catch (error) {
    yield put(emailPosOrderReceiptFailure(error));
  }
}

//REFUND_POS_ORDER
function* refundPosOrder({ payload }) {
  try {
    const response = yield call(refundPosOrderAPI, payload);
    yield put(refundPosOrderSuccess(response));
  } catch (error) {
    yield put(refundPosOrderFailure(error));
  }
}

// Watcher Sagas

export function* watchGetPosSystemRenderData() {
  yield takeEvery(GET_POS_SYSTEM_RENDER_DATA, getPosSystemRenderDataItems);
}

export function* watchGetPosSystemList() {
  yield takeEvery(GET_POS_SYSTEM_LIST, getPosSystemList);
}

export function* watchGetPosSystemData() {
  yield takeEvery(GET_POS_SYSTEM_DATA, getPosSystemData);
}

export function* watchCreatePosSystem() {
  yield takeEvery(CREATE_POS_SYSTEM, createPosSystem);
}

export function* watchUpdatePosSystem() {
  yield takeEvery(UPDATE_POS_SYSTEM, updatePosSystem);
}

export function* watchDeletePosSystem() {
  yield takeEvery(DELETE_POS_SYSTEM, deletePosSystem);
}

//GET_POS_SYSTEM_TO_USER_LIST
export function* watchGetPosSystemToUserList() {
  yield takeEvery(GET_POS_SYSTEM_TO_USER_LIST, getPosSystemToUserList);
}

//GET_POS_SYSTEM_TO_USER_DATA
export function* watchGetPosSystemToUserData() {
  yield takeEvery(GET_POS_SYSTEM_TO_USER_DATA, getPosSystemToUserData);
}

//CREATE_POS_SYSTEM_TO_USER
export function* watchCreatePosSystemToUser() {
  yield takeEvery(CREATE_POS_SYSTEM_TO_USER, createPosSystemToUser);
}

//UPDATE_POS_SYSTEM_TO_USER
export function* watchUpdatePosSystemToUser() {
  yield takeEvery(UPDATE_POS_SYSTEM_TO_USER, updatePosSystemToUser);
}

//DELETE_POS_SYSTEM_TO_USER
export function* watchDeletePosSystemToUser() {
  yield takeEvery(DELETE_POS_SYSTEM_TO_USER, deletePosSystemToUser);
}

export function* watchGetPosOrderList() {
  yield takeEvery(GET_POS_ORDER_LIST, getPosOrderList);
}

export function* watchPosOrderSearch() {
  yield takeEvery(POS_ORDER_SEARCH, posOrderSearch);
}

export function* watchGetPosOrderData() {
  yield takeEvery(GET_POS_ORDER_DATA, getPosOrderData);
}

export function* watchCreatePosOrder() {
  yield takeEvery(CREATE_POS_ORDER, createPosOrder);
}

export function* watchUpdatePosOrder() {
  yield takeEvery(UPDATE_POS_ORDER, updatePosOrder);
}

export function* watchDeletePosOrder() {
  yield takeEvery(DELETE_POS_ORDER, deletePosOrder);
}

export function* watchCreatePosOrderPaymentRequest() {
  yield takeEvery(CREATE_POS_ORDER_PAYMENT_REQUEST, createPosOrderPaymentRequest);
}

export function* watchCreatePosOrderTender() {
  yield takeEvery(CREATE_POS_ORDER_TENDER, createPosOrderTender);
}

export function* watchGetPosSystemOverview() {
  yield takeEvery(GET_POS_SYSTEM_OVERVIEW, getPosSystemOverview);
}

export function* watchVoidPosOrderPaymentRequest() {
  yield takeEvery(VOID_POS_ORDER_PAYMENT_REQUEST, voidPosOrderPaymentRequest);
}

export function* watchPrintPosOrderReceipt() {
  yield takeEvery(PRINT_POS_ORDER_RECEIPT, printPosOrderReceipt);
}

export function* watchEmailPosOrderReceipt() {
  yield takeEvery(EMAIL_POS_ORDER_RECEIPT, emailPosOrderReceipt);
}

export function* watchRefundPosOrder() {
  yield takeEvery(REFUND_POS_ORDER, refundPosOrder);
}

// Main Saga Function
function* PosSystemSaga() {
  yield all([
    fork(watchGetPosSystemRenderData),
    fork(watchGetPosSystemList),
    fork(watchGetPosSystemData),
    fork(watchCreatePosSystem),
    fork(watchUpdatePosSystem),
    fork(watchDeletePosSystem),
    fork(watchGetPosSystemToUserList),
    fork(watchGetPosSystemToUserData),
    fork(watchCreatePosSystemToUser),
    fork(watchUpdatePosSystemToUser),
    fork(watchDeletePosSystemToUser),
    fork(watchGetPosOrderList),
    fork(watchPosOrderSearch),
    fork(watchGetPosOrderData),
    fork(watchCreatePosOrder),
    fork(watchUpdatePosOrder),
    fork(watchDeletePosOrder),
    fork(watchCreatePosOrderPaymentRequest),
    fork(watchCreatePosOrderTender),
    fork(watchGetPosSystemOverview),
    fork(watchVoidPosOrderPaymentRequest),
    fork(watchPrintPosOrderReceipt),
    fork(watchEmailPosOrderReceipt),
    fork(watchRefundPosOrder),
  ]);
}

export default PosSystemSaga;
